import { LogoutComponent } from './../components/logout/logout.component';
import { Component, OnInit, Input, Inject, ViewChild, ElementRef } from '@angular/core';
import { ToasterService } from 'angular5-toaster';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Session } from '../models/session';
import { User } from '../models/user';

@Injectable()
export class StorageService {
  @ViewChild('UploadModal') UploadModal: ElementRef;

  private localStorageService;
  private session: Session = null;
  modalRef: NgbModalRef;
  closeResult = '';

  constructor(private router: Router,
              private modalService: NgbModal,
              private toasterService: ToasterService) {

    this.localStorageService = localStorage;
    this.session = this.loadSessionData();
  }


  loadSessionData(): Session {
    var sessionStr = this.localStorageService.getItem('currentUser');
    return (sessionStr) ? <Session>JSON.parse(sessionStr) : null;
  } 

  setCurrentSession(session: Session): void {
    this.session = session;
    this.localStorageService.setItem('currentUser', JSON.stringify(session));
  }


  getCurrentSession(): Session {
    return this.session;
  }

  removeCurrentSession(): void {
    this.localStorageService.removeItem('currentUser');
    this.session = null;
  }

  getCurrentUser(): User {
    var session: Session = this.getCurrentSession();
    // console.log(session);
    return (session && session.usuario) ? session.usuario : null;
  }

  isAuthenticated(): boolean {
    return (this.getCurrentToken() != null) ? true : false;
  }

  getCurrentToken(): string {
    var session = this.getCurrentSession();
    return (session && session.token) ? session.token : null;
  }

  logout(): void {
    if (this.modalRef) this.modalRef.close();
    this.removeCurrentSession();
    this.router.navigate(['/login']);
  }
  passwordChanged(){
    this.removeCurrentSession();
    this.router.navigate(['/login']);
  }

  openLogout() {
    this.modalRef = this.modalService.open(LogoutComponent, { centered: true, keyboard: false, backdrop: 'static'});
    this.modalRef.result.then((result) => {
      if (result === 'x') {
       
        this.logout();
        window.location.reload();

      } 
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/storage.service.ts